export const isStandalone = (): boolean => {
  const location = globalThis?.location;

  if (!location) {
    return false;
  }

  const { search, pathname } = location;

  const isLegacyStandalone = search?.includes('standalone=true');
  const isFullStandalone = pathname?.includes('/lesson/') && !pathname?.includes('/course/');

  return isLegacyStandalone || isFullStandalone;
};
